import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Dropdown, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { useFavouriteSchoolClientMutation, useGetSchoolClientDataQuery, useUpdateSchoolClientMutation } from "store/services/clients/school.client";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { convertToMomentDate, dateFormat, getAge, userFullName } from "helpers/common";
import moment from "moment";
import Attachments from "components/shared/Attachments";
import TrackAttendance from "components/shared/TrackAttendance";
import GuardianDetailList from "components/shared/GuardianDetailList";
import AssignApprenticePop from "components/Modals/AssignApprenticePop";
import { store } from "store/store";
import p1 from "Assets/images/user.png";
import ClientFreeAppointment from "components/shared/ClientFreeAppointment";
import { useClientsServiceStatusListQuery } from "store/services/utility";
import { Breadcrumbs, CommonSelect, CstmPagination, NoRecordFound } from "components/Common/Common";
import ServiceStatusUpdateField from "../../Components/ServiceStatusUpdateField";
import { CLIENT_TYPE_KEYS, NO_HISTORY_FOUND, SERVICE_STATUS_OPTIONS } from "config/constants";
import { useGetClientCaseloadsListQuery, useUpdateTherapistServiceStatusMutation } from "store/services/clientCaseLoads";
import { ListReports } from "../../ListReports";
import { CLIENT_ATTENDANCE_LIST, CLIENT_DOCUMENTS_LIST, CLIENT_REPORTS_LIST, CLINICIANS_HISTORY, SCHOOL_CLIENT_LIST, SERVICE_STATUS_LIST } from "config/paths";
import { Star } from "react-feather";
import dots from "../../../../../Assets/images/three-dots.png"
import downArrow from "../../../../../Assets/images/downArro.png"
import TableLayoutV2 from "components/TableLayoutV2";
import { unset } from "lodash";
import NotesComponent from "components/shared/FormComponents/V2/Notes/NotesComponent";
import NotesComponentOld from "components/shared/FormComponents/NotesComponent";
import DiagnosisComponent from "components/shared/FormComponents/V2/Diagnosis/DiagnosisComponent";
import CliniciansAssignedComponent from "components/shared/FormComponents/V2/CliniciansAssigned/CliniciansAssignedComponent";
import AttendanceTrackerModal from "components/Modals/AttendanceTrackerModal";
import ClientAttachments from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachments";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import ReportsComponent from "components/shared/FormComponents/V2/ReportsComponent/ReportsComponent";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import NotesComponentV2 from "components/shared/FormComponents/V2/Notes/NotesComponentV2";

const ClientSchoolDetail = () => {

  const state = store.getState();
  const user = state.auth.user;
  const navigate = useNavigate()
  const [showAddApprenticeModal, setShowAddApprenticeModal] = useState(false);
  const [therapistCaseloadId, setTherapistCaseloadId] = useState(null);
  const [currentApprenticeId, setCurrentApprenticeId] = useState(null);
  const pageSize = 10
  const [currentPage, setCurrentPage] = useState(1)
  const [filter, setFilter] = useState({ search: "" })
  const clientType = "school"
  const [attendanceModal, setAttendanceModal] = useState(false)
  const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const { id: clientId } = useParams();
  const { data: clientDetails, isLoading, isFetching, refetch } = useGetSchoolClientDataQuery(clientId);
  const isDischarged = clientDetails?.status == 'discharegd'
  const isInactive = clientDetails?.status == 'inactive'
  const [updateClient, { isLoading: updateClientLoading }] = useUpdateSchoolClientMutation();
  const { data: caseLoadsList, isFetching: caseLoadsListFetching } = useGetClientCaseloadsListQuery({ id: clientId, page: currentPage, limit: pageSize, ...filter })
  const totalRecords = caseLoadsList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize)
  const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: "school" });
  const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }));
  const [updateTherpaistServiceStatus, { isLoading: updateTherpaistServiceStatusLoading }] = useUpdateTherapistServiceStatusMutation()
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteSchoolClientMutation()

  const breadcrumbItems = [
    { label: "School Client", path: SCHOOL_CLIENT_LIST },
    { label: userFullName(clientDetails) || "Client Details" },
  ];


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleServiceStatus = async (id, therapistId) => {
    const payload = {
      service_status: id
    }
    try {
      await updateTherpaistServiceStatus({ payload, id: therapistId }).unwrap()
      refetch()
    } catch (error) {
      console.log("Error updating service status: ", error)
    }
  }
  const data = {}
  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteClient({ data, id }).unwrap()
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }
  const therapist = {}

  useEffect(() => {
    if (clientDetails?.status == "discharged" || clientDetails?.status == "inactive") {
      setIsDisabled(true);
    }
  }, [clientDetails])




  return (
    <>
      <AssignApprenticePop
        show={showAddApprenticeModal}
        setShow={setShowAddApprenticeModal}
        caseloadId={therapistCaseloadId}
        refetch={refetch}
        currentApprenticeId={currentApprenticeId}
      />
      <AttendanceTrackerModal
        show={attendanceModal}
        setShow={setAttendanceModal}
        refetch={refetch}
        caseLoadId={clientDetails?.clientPendingCaseloads?.id}
      />
      <AddClientDocumentsModal
        show={clientsDocumentModal}
        setShow={setClientsDocumentModal}
        clientId={clientId}
        refetch={refetch}
      />
      <section
        style={{ backgroundColor: "#f5f5f500" }}
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          {
            isLoading ? <LoadingIndicator /> :
              <>
                {(favouriteClientLoading || isFetching) && <LoadingOverlay />}
                <Row className="pt-3">
                  <Col lg="7">
                    <Breadcrumbs items={breadcrumbItems} />
                  </Col>
                  <Col lg="5">
                    <div style={{ display: "flex", gap: "10px" }}>
                      {
                        <div style={{ marginLeft: "auto", width: "236px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                          <Row className="mb-1">
                            <Col lg='6'>
                              <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                            </Col>
                            <Col lg='6'>
                              <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE OF EXPIRY</h3>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg='6'>
                              <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: clientDetails?.status == 'active' && "#55A215", fontStyle: ["archived", "discharged"]?.includes(clientDetails?.status) && "italic" }}>{clientDetails?.status}</h2>
                            </Col>
                            <Col lg='6'>
                              <h2 className="black mb-0 forteen  text-start">{clientDetails?.client_detail?.date_of_expiry ? dateFormat(clientDetails?.client_detail?.date_of_expiry, "MMM DD, YYYY") : "--"}</h2>
                            </Col>
                          </Row>
                        </div>
                      }
                      <div style={{ width: "148px" }} onClick={() => { if (!isDisabled) setAttendanceModal(true) }}
                      >
                        <h2 style={{
                          border: "1px solid #93278F",
                          padding: "10px 12px",
                          cursor: (!isDisabled) ? "pointer" : "not-allowed",
                          opacity: (!isDisabled) ? 1 : 0.5,
                          pointerEvents: (!isDisabled) ? "auto" : "none"
                        }} className="themePurple mb-0 cursor-pointer proxima-regular forteen text-center">Track Attendance</h2>
                      </div>
                    </div>

                  </Col>
                </Row>
                <div style={{ marginTop: "-10px" }}>
                  {therapist?.therapist_discipline?.name && <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>{therapist?.therapist_discipline?.name}</h5>}
                  <p>
                    <div className="d-flex gap-2 proxima-regular">
                      <div className="cursor-pointer" onClick={() => { handleFavouriteReport(clientDetails?.client_detail?.id, clientDetails?.client_detail?.is_favorite ? 0 : 1) }}>{clientDetails?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" /> : <Star />}
                      </div>
                      <Row className="w-100 align-items-center">
                        <Col lg='9'>
                          <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000" }}>
                            {clientDetails?.status != 'active' && <div className="text-capitalize">{`${clientDetails?.status}:`}</div>}{" "}{userFullName(clientDetails)} <span onClick={() => navigate(generatePath(SERVICE_STATUS_LIST, { clientId, clientType }))} className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SERVICE STATUS</span>
                          </p>
                        </Col>
                        <Col lg='3'>
                          <div onClick={() => navigate(generatePath(CLIENT_ATTENDANCE_LIST, { clientId, clientType }))} className="text-end">
                            <span className="themePurple cursor-pointer ten ms-2 fw-medium fs-8" style={{ textDecoration: "underline", marginTop: clientDetails?.status != 'active' && "10px" }}>SEE ATTENDANCE DETAILS</span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </p>
                </div>
                <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="date-title d-flex justify-content-between">
                        <h6 className="mb-0" style={{ marginTop: "3px" }}>CLIENT INFORMATION</h6>
                        <div className="d-flex align-items-center gap-2">
                          {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                          <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(data?.record?.reportsPreflightTeacher)}</p>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap gap-3 text-dark align-items-center justify-content-between">
                        <div className="d-flex text-dark align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>DATE OF BIRTH</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "16px" }}>{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GENDER</h5>
                            <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "16px" }}>{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "16px" }}>{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex text-dark align-items-center gap-4" style={{ marginRight: "60px", paddingRight: "40px" }}>
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "16px" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "16px" }}>{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex pt-3 align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="date-title d-flex justify-content-between">
                        <h6 className="mb-0" style={{ marginTop: "3px" }}>SCHOOL</h6>
                      </div>
                      <div className="d-flex flex-wrap gap-3 text-dark align-items-center justify-content-between">
                        <div className="d-flex text-dark align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>SCHOOL DIVISION</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{clientDetails?.client_detail?.client_school_detail?.client_school_division?.title || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>SCHOOL</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{clientDetails?.client_detail?.client_school_detail?.client_school?.name || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex text-dark align-items-center gap-4">
                          {/* <div>
                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CLASS ID</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      {
                        clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => index <= 1 && <>
                          <div className="date-title d-flex justify-content-between pt-3">
                            <h6 className="mb-0" style={{ marginTop: "3px" }}>{index == 0 ? "TEACHER" : "COORDINATOR"}</h6>
                          </div>
                          <div className="d-flex flex-wrap gap-3 text-dark align-items-center justify-content-between">
                            <div className="d-flex text-dark align-items-center gap-5">
                              <div>
                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>LAST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{item?.client_guardian?.lastname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>FIRST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{item?.client_guardian?.firstname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>EMAIL</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{item?.client_guardian?.email || "--"}</p>
                              </div>
                            </div>
                          </div>
                        </>)
                      }
                    </div>
                  </div>

                </div>

                <section>
                  <Row className="pt-4">
                    <Col lg="6">
                      {/* <NotesComponent
                        client_id={clientId}
                        module={"clients-school"}
                        disabled={isDischarged}
                      /> */}
                      <NotesComponentV2
                        client_id={clientId}
                        module={"clients-school"}
                        v2={true}
                      />
                    </Col>
                    <Col lg="6">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Col lg='12'>
                          <h6 className="mb-0 proxima-regular" style={{ marginTop: "3px" }}>CLINICIANS ASSIGNED
                            <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW HISTORY</span>
                          </h6>
                        </Col>
                        <CliniciansAssignedComponent refetch={refetch} clientDetails={clientDetails} />
                      </div>
                      <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <h6 onClick={() => navigate(generatePath(CLIENT_DOCUMENTS_LIST, { clientId, clientType }))} className="mb-0 proxima-regular" style={{ marginTop: "3px" }}>DOCUMENTS
                              <span className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span>
                            </h6>
                          </Col>
                          <Col onClick={() => !isDisabled && setClientsDocumentModal(true)} lg='4' className="text-end">
                            <svg style={{ opacity: isDisabled && "0.5" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" className="mx-1"><mask id="mask0_0_12941" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{ maskType: "alpha" }}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_0_12941)"><path d="M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z" fill="#93278F"></path></g></svg>
                          </Col>
                        </Row>
                        <ClientAttachments
                          isPage={false}
                          resources={clientDetails?.clientResources || []}
                          clientId={clientId}
                          refetch={refetch}
                          clientType={CLIENT_TYPE_KEYS.school}
                          limit={4}
                        />
                      </div>
                    </Col>
                  </Row>
                </section>

                <section>
                  <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                    <ReportsComponent isDisabled={isDisabled} clientId={clientId} clientType={clientType} isPage={false} />
                  </div>
                </section>

                <section className="mt-4 pb-3">
                  <DiagnosisComponent client_id={clientId} clientType={clientType} />
                </section>

                <Row className="mt-5 mb-5">
                  <Col lg="12" className="my-3">
                    {/* <TrackAttendance
                      refetch={refetch}
                      caseLoadId={clientDetails?.clientPendingCaseloads?.id}
                      clientCaseloadTherapist={clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist || []}
                    /> */}
                  </Col>
                  {/* <Col lg="12" className="my-3">
                    {
                      clientDetails?.clientPendingCaseloads?.case_status != "complete" &&
                      <Row>
                        {
                          clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist?.map((item, index) => {
                            const apprenticeFound = item?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type != "veteran")
                            const veteranFound = item?.clientCaseloadMapping?.find(x => x?.therapist_id == user.id);

                            return (<Col md="6" className="my-2">
                              <h6 class="m-0 themeBlue fw-bold pb-2">
                                {" "}
                                <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                  ■
                                </span>{" "}
                                Discipline: {item?.caseDiscipline?.assign_term || "--"}
                              </h6>
                              <div
                                className="cardCstm rounded shadow"
                                style={{ border: "1px solid rgb(61, 160, 170)" }}
                              >
                                <div className="top px-2">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="left">
                                      <h6
                                        class="m-0 themeBlue fw-bold pb-2"
                                        style={{ fontSize: 14 }}
                                      >
                                        {" "}
                                        <span
                                          class=""
                                          style={{ color: " rgb(61, 160, 170)" }}
                                        >
                                          ■
                                        </span>{" "}
                                        Service Status
                                      </h6>
                                      <div className="content">
                                      </div>
                                    </div>
                                    <div className="right my-2">
                                      <h6
                                        class="m-0 themeBlue fw-bold pb-2"
                                        style={{ fontSize: 14 }}
                                      >
                                        {" "}
                                        <span
                                          class=""
                                          style={{ color: " rgb(61, 160, 170)" }}
                                        >
                                          ■
                                        </span>{" "}
                                        Referred
                                      </h6>
                                      <div className="content">
                                        <p
                                          className="m-0 "
                                          style={{
                                            maxWidth: "max-content",
                                            fontSize: 14,
                                          }}
                                        >
                                          {convertToMomentDate(item?.createdAt)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="left">
                                      <h6
                                        class="m-0 themeBlue fw-bold pb-2"
                                        style={{ fontSize: 14 }}
                                      >
                                        {" "}
                                        <span
                                          class=""
                                          style={{ color: " rgb(61, 160, 170)" }}
                                        >
                                          ■
                                        </span>{" "}
                                        Assessment Date
                                      </h6>
                                      <div className="content">
                                        <p
                                          className="m-0"
                                          style={{
                                            maxWidth: "max-content",
                                            fontSize: 14,
                                          }}
                                        >
                                          --
                                        </p>
                                      </div>
                                    </div>
                                    <div className="right my-2">
                                      <h6
                                        class="m-0 themeBlue fw-bold pb-2"
                                        style={{ fontSize: 14 }}
                                      >
                                        {" "}
                                        <span
                                          class=""
                                          style={{ color: " rgb(61, 160, 170)" }}
                                        >
                                          ■
                                        </span>{" "}
                                        Start Date
                                      </h6>
                                      <div className="content">
                                        <p
                                          className="m-0 "
                                          style={{
                                            maxWidth: "max-content",
                                            fontSize: 14,
                                          }}
                                        >
                                          {convertToMomentDate(clientDetails?.createdAt)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {
                                  item?.clientCaseloadMapping?.map((caseloadMapping, index) => {
                                    return (
                                      <div>
                                        <div
                                          key={index}
                                          className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                          style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                        >
                                          <div className="imgWrp flex-shrink-0">
                                            <img
                                              src={caseloadMapping?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                              alt=""
                                              className="img-fluid rounded-circle object-fit-cover"
                                              style={{ height: 30, width: 30 }}
                                            />
                                          </div>
                                          <div className="content">
                                            <h6 className="m-0 fw-sbold themeBlue text-capitalize">
                                              {userFullName(caseloadMapping?.caseTherapist)}
                                            </h6>
                                          </div>
                                          {
                                            ((veteranFound && apprenticeFound) && caseloadMapping?.caseTherapist?.therapist_detail?.type != "veteran") && user?.role_type == "veteran" && <Button
                                              style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                              disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                              onClick={() => {
                                                setTherapistCaseloadId(item?.id)
                                                setCurrentApprenticeId(apprenticeFound?.therapist_id);
                                                setShowAddApprenticeModal(true)
                                              }}
                                              className="d-flex align-items-center justify-content-center commonBtn"
                                            >
                                              Change
                                            </Button>
                                          }
                                        </div>
                                        {(veteranFound && !apprenticeFound) && <div style={{ borderTop: "1px solid rgb(61, 160, 170)" }} className="w-100 d-flex justify-content-center py-2 align-items-center">
                                          <Button
                                            disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                            style={{ height: "35px", width: "90%" }}
                                            onClick={() => {
                                              setTherapistCaseloadId(item?.id)
                                              setShowAddApprenticeModal(true)
                                            }}
                                            className="d-flex align-items-center justify-content-center commonBtn"
                                          >
                                            Assign Apprentice
                                          </Button>
                                        </div>}
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </Col>)
                          })
                        }
                      </Row>
                    }
                  </Col> */}
                </Row>
                {/* 
                <Col
                  lg="6"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  {(isFetching || caseLoadsListFetching || updateClientLoading || updateTherpaistServiceStatusLoading || serviceStatusListLoading) && <LoadingOverlay />}
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="pageHead proxima d-flex align-items-center justify-content-between flex-wrap gap-10">
                        <div className="left">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold"
                                style={{ textDecoration: "underline" }}
                                to={SCHOOL_CLIENT_LIST}
                              >
                                Client
                              </Link>
                            </li>
                            <li className="">
                              <h5 className="m-0 fw-bold themeBlue">
                                / Student Details
                              </h5>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="top d-flex align-items-center gap-10">
                        <div
                          className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                          style={{ height: 35, width: 35, background: "#DBDBDB" }}
                        >
                          {clientDetails?.firstname[0]?.toUpperCase() + clientDetails?.lastname[0]?.toUpperCase()}
                        </div>
                        <div className="content">
                          <h6 className="m-0 themeBlue fw-sbold text-capitalize">{userFullName(clientDetails)}</h6>
                        </div>
                      </div>
                      <Row>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              DOB
                            </h6>
                            <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Gender
                            </h6>
                            <p className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              School
                            </h6>
                            <p className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.client_school_detail?.client_school?.name || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Grade
                            </h6>
                            <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.grade || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              City/Town
                            </h6>
                            <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Funded Sessions
                            </h6>
                            <p className="m-0 themeBlue pt-2">{clientDetails?.clientAppointment?.booked || 0}/{clientDetails?.clientAppointmentBalance?.balance || 0}</p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12" className="my-3">
                      <NotesComponent
                        client_id={clientId}
                        module={"clients-school"}
                      />
                    </Col>
                    <GuardianDetailList
                      clientId={clientId}
                      type="Teacher"
                      guardianList={clientDetails?.client_detail?.client_guardian_mapping || []}
                    />
                    <Col lg="12" className="my-3">
                      {
                        clientDetails?.clientPendingCaseloads?.case_status != "complete" &&
                        <Row>
                          {
                            clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist?.map((item, index) => {
                              const apprenticeFound = item?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type != "veteran")
                              const veteranFound = item?.clientCaseloadMapping?.find(x => x?.therapist_id == user.id);

                              return (<Col md="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold pb-2">
                                  {" "}
                                  <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                    ■
                                  </span>{" "}
                                  Discipline: {item?.caseDiscipline?.assign_term || "--"}
                                </h6>
                                <div
                                  className="cardCstm rounded shadow"
                                  style={{ border: "1px solid rgb(61, 160, 170)" }}
                                >
                                  <div className="top px-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="left">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Service Status
                                        </h6>
                                        <div className="content">
                                          <Dropdown onSelect={(e) => handleServiceStatus(e, item?.id)}>
                                            <Dropdown.Toggle
                                              disabled={user.id != item?.clientCaseloadMapping?.[0]?.therapist_id}
                                              className="border-0 text-dark px-3 py-1 d-flex align-items-center justify-content-between fw-sbold"
                                              style={{
                                                background: "#F3F3F3",
                                                height: "32px",
                                                fontSize: "13px",
                                                borderRadius: "20px",
                                                minWidth: "130px",
                                                boxShadow: "inset 0 0 2px #ccc",
                                              }}
                                              id="dropdown-basic"
                                            >
                                              <span style={{ whiteSpace: "nowrap" }}>{item?.caseServiceStatus?.title}</span>
                                              <span<Col lg="12" className="my-3">
                      {
                        clientDetails?.clientPendingCaseloads?.case_status != "complete" &&
                        <Row>
                          {
                            clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist?.map((item, index) => {
                              const apprenticeFound = item?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type != "veteran")
                              const veteranFound = item?.clientCaseloadMapping?.find(x => x?.therapist_id == user.id);

                              return (<Col md="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold pb-2">
                                  {" "}
                                  <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                    ■
                                  </span>{" "}
                                  Discipline: {item?.caseDiscipline?.assign_term || "--"}
                                </h6>
                                <div
                                  className="cardCstm rounded shadow"
                                  style={{ border: "1px solid rgb(61, 160, 170)" }}
                                >
                                  <div className="top px-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="left">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Service Status
                                        </h6>
                                        <div className="content">
                                          <Dropdown onSelect={(e) => handleServiceStatus(e, item?.id)}>
                                            <Dropdown.Toggle
                                              disabled={user.id != item?.clientCaseloadMapping?.[0]?.therapist_id}
                                              className="border-0 text-dark px-3 py-1 d-flex align-items-center justify-content-between fw-sbold"
                                              style={{
                                                background: "#F3F3F3",
                                                height: "32px",
                                                fontSize: "13px",
                                                borderRadius: "20px",
                                                minWidth: "130px",
                                                boxShadow: "inset 0 0 2px #ccc",
                                              }}
                                              id="dropdown-basic"
                                            >
                                              <span style={{ whiteSpace: "nowrap" }}>{item?.caseServiceStatus?.title}</span>
                                              <span className="ms-2">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="10"
                                                  height="5"
                                                  viewBox="0 0 10 5"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                                    fill="#1C1B1F"
                                                  />
                                                </svg>
                                              </span>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="w-100 small p-0" style={{ fontSize: "13px" }}>
                                              {
                                                serviceStatusOptions?.map((item, index) => (
                                                  <Dropdown.Item key={index} eventKey={item.value}>
                                                    {item.label}
                                                  </Dropdown.Item>
                                                ))
                                              }
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </div>
                                      <div className="right my-2">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Referred
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0 "
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            {convertToMomentDate(item?.createdAt)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="left">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Assessment Date
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0"
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            --
                                          </p>
                                        </div>
                                      </div>
                                      <div className="right my-2">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Start Date
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0 "
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            {convertToMomentDate(clientDetails?.createdAt)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {
                                    item?.clientCaseloadMapping?.map((caseloadMapping, index) => {
                                      return (
                                        <div>
                                          <div
                                            key={index}
                                            className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                            style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                          >
                                            <div className="imgWrp flex-shrink-0">
                                              <img
                                                src={caseloadMapping?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                                alt=""
                                                className="img-fluid rounded-circle object-fit-cover"
                                                style={{ height: 30, width: 30 }}
                                              />
                                            </div>
                                            <div className="content">
                                              <h6 className="m-0 fw-sbold themeBlue text-capitalize">
                                                {userFullName(caseloadMapping?.caseTherapist)}
                                              </h6>
                                            </div>
                                            {
                                              ((veteranFound && apprenticeFound) && caseloadMapping?.caseTherapist?.therapist_detail?.type != "veteran") && user?.role_type == "veteran" && <Button
                                                style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                                onClick={() => {
                                                  setTherapistCaseloadId(item?.id)
                                                  setCurrentApprenticeId(apprenticeFound?.therapist_id);
                                                  setShowAddApprenticeModal(true)
                                                }}
                                                className="d-flex align-items-center justify-content-center commonBtn"
                                              >
                                                Change
                                              </Button>
                                            }
                                          </div>
                                          {(veteranFound && !apprenticeFound) && <div style={{ borderTop: "1px solid rgb(61, 160, 170)" }} className="w-100 d-flex justify-content-center py-2 align-items-center">
                                            <Button
                                              disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                              style={{ height: "35px", width: "90%" }}
                                              onClick={() => {
                                                setTherapistCaseloadId(item?.id)
                                                setShowAddApprenticeModal(true)
                                              }}
                                              className="d-flex align-items-center justify-content-center commonBtn"
                                            >
                                              Assign Apprentice
                                            </Button>
                                          </div>}
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </Col> className="ms-2">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="10"
                                                  height="5"
                                                  viewBox="0 0 10 5"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                                    fill="#1C1B1F"
                                                  />
                                                </svg>
                                              </span>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="w-100 small p-0" style={{ fontSize: "13px" }}>
                                              {
                                                serviceStatusOptions?.map((item, index) => (
                                                  <Dropdown.Item key={index} eventKey={item.value}>
                                                    {item.label}
                                                  </Dropdown.Item>
                                                ))
                                              }
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </div>
                                      <div className="right my-2">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Referred
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0 "
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            {convertToMomentDate(item?.createdAt)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="left">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Assessment Date
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0"
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            --
                                          </p>
                                        </div>
                                      </div>
                                      <div className="right my-2">
                                        <h6
                                          class="m-0 themeBlue fw-bold pb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          {" "}
                                          <span
                                            class=""
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■
                                          </span>{" "}
                                          Start Date
                                        </h6>
                                        <div className="content">
                                          <p
                                            className="m-0 "
                                            style={{
                                              maxWidth: "max-content",
                                              fontSize: 14,
                                            }}
                                          >
                                            {convertToMomentDate(clientDetails?.createdAt)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {
                                    item?.clientCaseloadMapping?.map((caseloadMapping, index) => {
                                      return (
                                        <div>
                                          <div
                                            key={index}
                                            className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                            style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                          >
                                            <div className="imgWrp flex-shrink-0">
                                              <img
                                                src={caseloadMapping?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                                alt=""
                                                className="img-fluid rounded-circle object-fit-cover"
                                                style={{ height: 30, width: 30 }}
                                              />
                                            </div>
                                            <div className="content">
                                              <h6 className="m-0 fw-sbold themeBlue text-capitalize">
                                                {userFullName(caseloadMapping?.caseTherapist)}
                                              </h6>
                                            </div>
                                            {
                                              ((veteranFound && apprenticeFound) && caseloadMapping?.caseTherapist?.therapist_detail?.type != "veteran") && user?.role_type == "veteran" && <Button
                                                style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                                onClick={() => {
                                                  setTherapistCaseloadId(item?.id)
                                                  setCurrentApprenticeId(apprenticeFound?.therapist_id);
                                                  setShowAddApprenticeModal(true)
                                                }}
                                                className="d-flex align-items-center justify-content-center commonBtn"
                                              >
                                                Change
                                              </Button>
                                            }
                                          </div>
                                          {(veteranFound && !apprenticeFound) && <div style={{ borderTop: "1px solid rgb(61, 160, 170)" }} className="w-100 d-flex justify-content-center py-2 align-items-center">
                                            <Button
                                              disabled={item?.caseServiceStatus?.title.toLowerCase() == 'discharge'}
                                              style={{ height: "35px", width: "90%" }}
                                              onClick={() => {
                                                setTherapistCaseloadId(item?.id)
                                                setShowAddApprenticeModal(true)
                                              }}
                                              className="d-flex align-items-center justify-content-center commonBtn"
                                            >
                                              Assign Apprentice
                                            </Button>
                                          </div>}
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </Col>)
                            })
                          }
                        </Row>
                      }
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="d-flex align-items-center justify-content-between my-3">
                        <div>
                          <h6 className="m-0 fw-bold">Caseload History</h6>
                         
                        </div>
                        <div>
                
                        </div>
                      </div>
                      {
                        caseLoadsList?.record?.clientCaseloads?.length > 0 ?
                          <div>
                            <Accordion className="my-4" >
                              {
                                caseLoadsList?.record?.clientCaseloads?.map((item, index) =>
                                  <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header className='staff-client-accordion'>
                                      <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center'>
                                        <div>
                                          <div className='mb-2'>
                                            <span>Discharge Date:</span> {convertToMomentDate(item?.discharge_date)}
                                          </div>

                                        </div>
                                        <div style={{ marginRight: "10px" }}>

                                        </div>
                                      </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <Col lg="12" className="my-3">
                                        {
                                          item?.clientCaseloadTherapist?.length > 0 && (
                                            <Row>
                                              {item?.clientCaseloadTherapist?.map(assignment => {
                                                if (assignment?.status != 65) return (
                                                  <Col md="6" className="my-2">
                                                    <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                                                      <h6 class="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                                          ■
                                                        </span>{" "}
                                                        Discipline: {assignment?.caseDiscipline?.assign_term}

                                                      </h6>
                                                  
                                                    </div>
                                                    <div
                                                      className="cardCstm rounded shadow"
                                                      style={{ border: "1px solid rgb(61, 160, 170)" }}
                                                    >
                                                      <div className="top px-2">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          <div className="left">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Service Status
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0 status border fw-sbold px-3 inline-block text-center rounded-pill yellowStatus"
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                {assignment?.caseServiceStatus?.title}
                                                              </p>
                                                            </div>
                                                          </div>
                                                          <div className="right my-2">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Referred
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0 "
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                {convertToMomentDate(assignment?.createdAt)}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          <div className="left">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Assessment Date
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0"
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                --
                                                              </p>
                                                            </div>
                                                          </div>
                                                          <div className="right my-2">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Start Date
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0 "
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                {convertToMomentDate(clientDetails?.createdAt)}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {
                                                        assignment?.clientCaseloadMapping?.map((item, index) => {
                                                          return (
                                                            <div
                                                              className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                                              style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                                              key={index}
                                                            >
                                                              <div className="imgWrp flex-shrink-0">
                                                                <img
                                                                  src={item?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                                                  alt=""
                                                                  className="img-fluid rounded-circle object-fit-cover"
                                                                  style={{ height: 30, width: 30 }}
                                                                />
                                                              </div>
                                                              <div className="content">
                                                                <h6 className="m-0 fw-sbold themeBlue">
                                                                  {userFullName(item?.caseTherapist)}
                                                                </h6>
                                                              </div>

                                                            </div>
                                                          )
                                                        })
                                                      }
                                                    </div>
                                                  </Col>
                                                )
                                              })}
                                            </Row>
                                          )
                                        }
                                      </Col>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                )
                              }
                            </Accordion>
                            <CstmPagination
                              totalPages={totalPages}
                              activePage={currentPage}
                              handlePageChange={handlePageChange}
                            />
                          </div> : <NoRecordFound showBorder message={NO_HISTORY_FOUND} />
                      }
                    </Col>
                  </Row>
                </Col> */}
                {/* <Col lg="6" className="">
                  <Row>
                    <TrackAttendance
                      refetch={refetch}
                      caseLoadId={clientDetails?.clientPendingCaseloads?.id}
                      clientCaseloadTherapist={clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist || []}
                    />
                    <Attachments
                      resources={clientDetails?.clientResources || []}
                      clientId={clientId}
                      refetch={refetch}
                      clientType={CLIENT_TYPE_KEYS.school}
                    />
                    <ListReports />
                  </Row>
                </Col> */}
              </>
          }
          {/* <ListReports /> */}
        </Container >
      </section >
    </>
  );
};

export default ClientSchoolDetail;


